import React from 'react';
import { Link } from 'react-router-dom';
import Eyebrow from '../motion/Eyebrow';
import KineticHeadline from '../motion/KineticHeadline';
import Reveal from '../motion/Reveal';
import LoopVideo from '../motion/LoopVideo';
import Parallax from '../motion/Parallax';
import Magnetic from '../motion/Magnetic';

const CHIPS = ['Make picks', 'Live leaderboard', 'Corner Chat', 'Lock sheet', 'Badges', 'Invite links'];

/** THE APP: the tilted wall of app screens drifts behind the headline, dissolved into the ink. */
export default function AppWallSection() {
  return (
    <section className="pnp-wall" aria-labelledby="pnp-wall-title">
      <div className="pnp-wall-bg" aria-hidden="true">
        <Parallax speed={0.14} max={220}>
          <LoopVideo name="app-wall" feather="none" label="A tilted wall of Pick 'N Pray app screens" />
          <div className="pnp-wall-veil" />
        </Parallax>
        <div className="pnp-wall-pool" />
        <div className="pnp-glow pnp-glow-center" style={{ top: '50%', marginTop: -500, opacity: 0.55 }} />
      </div>
      <div className="pnp-wrap pnp-center">
        <Eyebrow>The app</Eyebrow>
        <div id="pnp-wall-title" style={{ marginTop: 24 }}><KineticHeadline className="pnp-display pnp-h1" text={'The whole card.\n*In your pocket.*'} /></div>
        <Reveal delay={300}>
          <p className="pnp-lead pnp-halo" style={{ margin: '28px auto 0', maxWidth: '52ch', color: 'rgba(246,248,251,0.82)' }}>
            Picks, the live leaderboard, Corner Chat, your lock sheet and your badges, on your phone or your laptop.
            Open picknpray.com in any browser and you&apos;re in.
          </p>
        </Reveal>
        <Reveal delay={420} className="pnp-chips">
          {CHIPS.map((c) => <span key={c} className="pnp-chip">{c}</span>)}
        </Reveal>
        <Reveal delay={540} style={{ marginTop: 40 }}>
          <Magnetic>
            <Link to="/register" className="pnp-btn pnp-btn-primary pnp-btn-lg">Join free <span className="pnp-btn-arrow" aria-hidden="true">→</span></Link>
          </Magnetic>
        </Reveal>
      </div>
    </section>
  );
}
